import { programs, aboutContent } from '@/data/mock';
import usePageTitle from '@/hooks/usePageTitle';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ProgramsPage = () => {
  usePageTitle('Programs');
  return (
    <div>
      {/* Hero Section - Dark */}
      <section className="bg-brand-dark py-20 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-3xl lg:text-4xl font-semibold text-white mb-6">
              Our Programs & Events
            </h1>
            <p className="text-lg text-gray-400">
              {aboutContent.mission}
            </p>
            <p className="text-brand-gold/80 text-sm font-medium tracking-wide mt-4">You are not alone.</p>
          </div>
        </div>
      </section>

      {/* Programs List - Documentation Style */}
      <section className="bg-brand-light py-16 lg:py-20">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="space-y-16">
            {programs.map((program) => (
              <article key={program.id} className="max-w-3xl">
                {/* Special layout for Men's Mental Health Resets with image on top */}
                {program.id === 1 ? (
                  <div>
                    <img
                      src="/images/site/program1.png"
                      alt="Men's Mental Health Reset - Disc Golf"
                      className="w-44 h-auto mb-6"
                    />
                    <h2 className="text-xl lg:text-2xl font-semibold text-brand-dark mb-2">
                      {program.title}
                      {program.subtitle && (
                        <span className="text-gray-500 font-normal text-lg"> — {program.subtitle}</span>
                      )}
                    </h2>
                    
                    <div className="mt-6 space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Who it's for
                        </h3>
                        <p className="text-gray-700">{program.whoFor}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          What it is
                        </h3>
                        <p className="text-gray-700">{program.whatItIs}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Why it matters
                        </h3>
                        <p className="text-gray-700">{program.whyItMatters}</p>
                      </div>
                    </div>
                  </div>
                ) : program.id === 2 ? (
                  <div>
                    <img
                      src="/images/site/program2.png"
                      alt="Women's Workshops & Healing Circles"
                      className="w-44 h-auto mb-6"
                    />
                    <h2 className="text-xl lg:text-2xl font-semibold text-brand-dark mb-2">
                      {program.title}
                      {program.subtitle && (
                        <span className="text-gray-500 font-normal text-lg"> — {program.subtitle}</span>
                      )}
                    </h2>
                    
                    <div className="mt-6 space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Who it's for
                        </h3>
                        <p className="text-gray-700">{program.whoFor}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          What it is
                        </h3>
                        <p className="text-gray-700">{program.whatItIs}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Why it matters
                        </h3>
                        <p className="text-gray-700">{program.whyItMatters}</p>
                      </div>
                    </div>
                  </div>
                ) : program.id === 3 ? (
                  <div>
                    <img
                      src="/images/site/program3.png"
                      alt="Elevated Takeover @ Ely's Peak"
                      className="w-44 h-auto mb-6"
                    />
                    <h2 className="text-xl lg:text-2xl font-semibold text-brand-dark mb-2">
                      {program.title}
                      {program.subtitle && (
                        <span className="text-gray-500 font-normal text-lg"> — {program.subtitle}</span>
                      )}
                    </h2>
                    
                    <div className="mt-6 space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Who it's for
                        </h3>
                        <p className="text-gray-700">{program.whoFor}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          What it is
                        </h3>
                        <p className="text-gray-700">{program.whatItIs}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Why it matters
                        </h3>
                        <p className="text-gray-700">{program.whyItMatters}</p>
                      </div>
                    </div>
                  </div>
                ) : program.id === 4 ? (
                  <div>
                    <img
                      src="/images/site/program4.jpg"
                      alt="The Elevated Invitational - Cornhole Tournament"
                      className="w-44 h-auto mb-6"
                    />
                    <h2 className="text-xl lg:text-2xl font-semibold text-brand-dark mb-2">
                      {program.title}
                      {program.subtitle && (
                        <span className="text-gray-500 font-normal text-lg"> — {program.subtitle}</span>
                      )}
                    </h2>
                    
                    <div className="mt-6 space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Who it's for
                        </h3>
                        <p className="text-gray-700">{program.whoFor}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          What it is
                        </h3>
                        <p className="text-gray-700">{program.whatItIs}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Why it matters
                        </h3>
                        <p className="text-gray-700">{program.whyItMatters}</p>
                      </div>
                    </div>
                  </div>
                ) : program.id === 5 ? (
                  <div>
                    <img
                      src="/images/site/program5.jpg"
                      alt="Christmas Compassion Toy Drive"
                      className="w-44 h-auto mb-6"
                    />
                    <h2 className="text-xl lg:text-2xl font-semibold text-brand-dark mb-2">
                      {program.title}
                      {program.subtitle && (
                        <span className="text-gray-500 font-normal text-lg"> — {program.subtitle}</span>
                      )}
                    </h2>
                    
                    <div className="mt-6 space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Who it's for
                        </h3>
                        <p className="text-gray-700">{program.whoFor}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          What it is
                        </h3>
                        <p className="text-gray-700">{program.whatItIs}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Why it matters
                        </h3>
                        <p className="text-gray-700">{program.whyItMatters}</p>
                      </div>
                    </div>
                  </div>
                ) : program.id === 6 ? (
                  <div>
                    <img
                      src="/images/site/program6.jpg"
                      alt="Christmas at the Brownstone"
                      className="w-44 h-auto mb-6"
                    />
                    <h2 className="text-xl lg:text-2xl font-semibold text-brand-dark mb-2">
                      {program.title}
                      {program.subtitle && (
                        <span className="text-gray-500 font-normal text-lg"> — {program.subtitle}</span>
                      )}
                    </h2>
                    
                    <div className="mt-6 space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Who it's for
                        </h3>
                        <p className="text-gray-700">{program.whoFor}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          What it is
                        </h3>
                        <p className="text-gray-700">{program.whatItIs}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Why it matters
                        </h3>
                        <p className="text-gray-700">{program.whyItMatters}</p>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <h2 className="text-xl lg:text-2xl font-semibold text-brand-dark mb-2">
                      {program.title}
                      {program.subtitle && (
                        <span className="text-gray-500 font-normal text-lg"> — {program.subtitle}</span>
                      )}
                    </h2>
                    
                    <div className="mt-6 space-y-4">
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Who it's for
                        </h3>
                        <p className="text-gray-700">{program.whoFor}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          What it is
                        </h3>
                        <p className="text-gray-700">{program.whatItIs}</p>
                      </div>
                      
                      <div>
                        <h3 className="text-sm font-semibold text-brand-dark uppercase tracking-wide mb-1">
                          Why it matters
                        </h3>
                        <p className="text-gray-700">{program.whyItMatters}</p>
                      </div>
                    </div>
                  </>
                )}

                <div className="mt-8 border-b border-gray-300"></div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProgramsPage;
